// ConfirmContext.jsx
import React, { createContext, useState, useContext } from 'react';
import { ConfirmDialog } from './ConfirmDialog';

const ConfirmContext = createContext();

export const useConfirm = () => {
    return useContext(ConfirmContext);
};

export const ConfirmProvider = ({ children }) => {
    const [confirmState, setConfirmState] = useState({
        open: false,
        title: '',
        content: '',
        resolve: null,
        reject: null,
    });

    const showConfirm = ({ title, content, ...rest }) => {
        return new Promise((resolve, reject) => {
            setConfirmState({
                open: true,
                title,
                content,
                resolve,
                reject,
                ...rest
            });
        });
    };

    const handleConfirm = () => {
        if (confirmState.resolve) {
            confirmState.resolve(true);
        }
        setConfirmState({
            ...confirmState,
            open: false,
            resolve: null,
            reject: null,
        });
    };

    const handleCancel = () => {
        if (confirmState.resolve) confirmState.resolve(null)
        setConfirmState({
            ...confirmState,
            open: false,
            resolve: null,
            reject: null,
        });
    };

    return (
        <ConfirmContext.Provider value={showConfirm}>
            {children}
            <ConfirmDialog
                open={confirmState.open}
                title={confirmState.title}
                content={confirmState.content}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                confirmText={confirmState.confirmText}
                cancelText={confirmState.cancelText}
            />
        </ConfirmContext.Provider>
    );
};